import { Component, Input, OnInit, Optional } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';

import { BehaviorSubject, Observable, map, switchMap, filter, delay } from 'rxjs';

import { ReportImportService } from 'src/app/services/report-import/report-import.service';
import { ReportSelectionImportMode } from 'src/app/services/report-import/utils';

import { IReportSelectorPopupInput, IReportSelectorPopupOuput, ReportSelectorComponent } from '../report-selector/report-selector.component';

import { ProfileService } from 'src/app/services/profile/profile.service';
import { BaseComponent } from '@leandredev/common_ng_14';
import { ReportProgressComponent } from '../report-progress/report-progress.component';
import { HttpErrorResponse, HttpEventType } from '@angular/common/http';

@Component({
  selector: 'app-report-list',
  templateUrl: './report-list.component.html',
  styleUrls: ['./report-list.component.scss']
})
export class ReportListComponent extends BaseComponent implements OnInit {
  @Input() view: 'button' | 'menu' | 'hidden' = 'menu';

  constructor(
    @Optional() private dialogRef: MatDialogRef<ReportListComponent, null>,
    private service: ReportImportService,
    private dialog: MatDialog,
    private profileService: ProfileService
  ) {
    super();
  }

  public isAuth = new BehaviorSubject(false);

  public enabledImport: boolean | undefined;

  public avalaible: boolean;

  close(): void {
    this.dialogRef.close();
  }

  ngOnInit(): void {
    this.subscription.add(
      this.profileService.profile
        .pipe(
          delay(500),
          switchMap((profile) => {
            this.isAuth.next(!!profile.allowImport);
            this.enabledImport = !!profile.allowImport;

            return this.service.isImportAvalaible();
          }),
          map((avalaible) => {
            this.avalaible = avalaible;
          })
        )
        .subscribe()
    );
  }

  public cancelOnNullValue(): (data: string[]) => boolean {
    return (data) => {
      if (!data) {
        return false;
      } else {
        return true;
      }
    };
  }

  public resetInput(element: HTMLInputElement): void {
    element.value = '';
  }

  public progressDialog: MatDialogRef<ReportProgressComponent, null>;

  private handleError(): (error: HttpErrorResponse) => void {
    return (error: HttpErrorResponse) => {
      if (error.status === 503) {
        if (this.progressDialog) this.progressDialog.close();
        this.dialog.open(ErrorBusyImportComponent);
      }

      if (error.status === 500) {
        this.dialog.open(ErrorDialogComponent);
      }
    };
  }

  public uploadGalleriesDataListener(files: File[]): void {
    const file = files[0];

    this.openSheetSeletorPopup(file, ReportSelectionImportMode.GALLERY)
      .pipe(
        filter(this.cancelOnNullValue()),
        switchMap(() => {
          return this.service.sendGallerieReportToServer(file).pipe(
            map((httpEvent) => {
              if (httpEvent.type == HttpEventType.UploadProgress && this.progressDialog == undefined) {
                this.openProgressPopup();
              }
            })
          );
        })
      )
      .subscribe({
        error: this.handleError()
      });
  }

  public uploadLocationsDataListener(files: File[]): void {
    const file = files[0];

    this.openSheetSeletorPopup(file, ReportSelectionImportMode.LOCATION)
      .pipe(
        filter(this.cancelOnNullValue()),
        switchMap(() => {
          return this.service.sendLocationsReportToServer(file).pipe(
            map((httpEvent) => {
              if (httpEvent.type == HttpEventType.UploadProgress && this.progressDialog == undefined) {
                this.openProgressPopup();
              }
            })
          );
        })
      )
      .subscribe({
        error: this.handleError()
      });
  }

  public uploadYearlyListener(files: File[]): void {
    const file = files[0];

    this.openSheetSeletorPopup(file, ReportSelectionImportMode.YEARLY)
      .pipe(
        filter(this.cancelOnNullValue()),
        filter((repportsToAdd) => repportsToAdd.length > 0),
        switchMap((repportsToAdd) => {
          return this.service.sendYearlyReportToServer(file, repportsToAdd).pipe(
            map((httpEvent) => {
              if (httpEvent.type == HttpEventType.UploadProgress && this.progressDialog == undefined) {
                this.openProgressPopup();
              }
            })
          );
        })
      )
      .subscribe({
        error: this.handleError()
      });
  }

  public uploadMonthlyReportsListener(files: File[]): void {
    const file = files[0];

    this.openSheetSeletorPopup(file, ReportSelectionImportMode.MONTHLY)
      .pipe(
        filter(this.cancelOnNullValue()),
        filter((monthNames) => monthNames.length > 0),
        switchMap((monthNames) => {
          return this.service.sendMonthlyReportToServer(file, monthNames).pipe(
            map((httpEvent) => {
              if (httpEvent.type == HttpEventType.UploadProgress && this.progressDialog == undefined) {
                this.openProgressPopup();
              }
            })
          );
        })
      )
      .subscribe({
        error: this.handleError()
      });
  }

  private openSheetSeletorPopup(file: File, mode: ReportSelectionImportMode): Observable<string[]> {
    this.dialogRef.close();

    return this.dialog
      .open<ReportSelectorComponent, IReportSelectorPopupInput, IReportSelectorPopupOuput>(ReportSelectorComponent, {
        disableClose: false,
        width: 'min(90vw, 900px)',
        maxWidth: '90vw',
        data: { file: file, mode: mode }
      })
      .afterClosed();
  }

  private openProgressPopup(): void {
    this.progressDialog = this.dialog.open<ReportProgressComponent, null, null>(ReportProgressComponent, {});
  }
}

@Component({
  selector: 'error-buzy-import',
  template: ` <h1 mat-dialog-title>Erreur</h1>
    <div mat-dialog-content>Le service est actuellent occupé</div>
    <div mat-dialog-actions>
      <button mat-button mat-dialog-close>Fermer</button>
    </div>`
})
export class ErrorBusyImportComponent {}

@Component({
  selector: 'error-dialog',
  template: ` <h1 mat-dialog-title>Erreur</h1>
    <div mat-dialog-content>Le service a rencontré une erreurs pendant l'importation</div>
    <div mat-dialog-actions>
      <button mat-button mat-dialog-close>Fermer</button>
    </div>`
})
export class ErrorDialogComponent {}
